import { useEffect } from "react";

// Lightweight SEO head manager (title, meta, canonical, JSON-LD).
export default function Seo({ title, description, canonical, jsonLd, image }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", "Horsepower Garage", "property");
    setMeta("og:locale", "fr_FR", "property");
    if (canonical) setMeta("og:url", canonical, "property");
    const img = image ? (image.startsWith("http") ? image : `https://www.horsepowergarage.fr${image}`) : "https://www.horsepowergarage.fr/photos/hero-beziers.jpg";
    setMeta("og:image", img, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", img);
    setMeta("robots", "index, follow, max-image-preview:large");

    let link = document.head.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }

    let script = document.getElementById("hp-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "hp-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, canonical, jsonLd]);

  return null;
}
